<cpc-policy-card [ngClass]="state.name" [variant]="state.badge">
    <cpc-policy-card-header class="cpc-policy-card-header_{{state.badge}}">
        <cpc-icon left [icon]="getGroupByLobId(policy.lineOfBusinessId).icon"
            color="{{ (policy.isElectricVehicle) ? '#3da556' : '#006192' }}" borderStyle="circle"
            backgroundColor="#fff"></cpc-icon>
        <ng-container center>
            <p translate *ngIf="!policy.isElectricVehicle">{{'claim.azk-lob.' + policy.lineOfBusinessId}}</p>
            <p translate *ngIf="policy.isElectricVehicle">{{'active-insurance-group.car-insurance-ek'}}</p>
            <container-element [ngSwitch]="LOB.setId(policy.lineOfBusinessId).lob">
                <h2 *ngSwitchCase="lob.CarInsurance">{{policy.model | stringFormat}}&nbsp;-
                    {{policy.crn | stringFormat}}</h2>
                <h2 *ngSwitchCase="lob.LifeInsurance">{{policy.firstInsuredName | stringFormat}}</h2>
                <h2 *ngSwitchCase="lob.HomeInsurance">{{policy.householdAddress | stringFormat}}</h2>
                <h2 *ngSwitchCase="lob.TravelInsurance">{{ policy.beginDate | stringFormat | dateFormat }},
                    {{ policy.endDate | stringFormat | dateFormat}}</h2>
            </container-element>
        </ng-container>
    </cpc-policy-card-header>


    <cpc-policy-card-content class="policy-card-content" [borderBottom]="false">
        <cpc-policy-card-entry skipFromHeightAligment="true" align="space-between">

            <span title translate class="policy-card-pn">policy.policy-number<b>{{policy.policyNumber}}</b></span>
            <container-element [ngSwitch]="LOB.setId(policy.lineOfBusinessId).lob">
                <span *ngSwitchCase="lob.LifeInsurance">
                    <button nxPlainButton type="button" class="file-a-claim"
                        (click)="claimMyData(policy.policyNumber, policy.detailTypeIdentifier.toLowerCase(), policy.lineOfBusinessId)">
                        {{ 'policy.file-a-claim' | translate }}<nx-icon name="launch"
                            class="nx-margin-left-2xs"></nx-icon>
                    </button>
                </span>
                <span *ngSwitchCase="lob.TravelInsurance">
                    <button nxPlainButton type="button" class="file-a-claim" (click)="claimMyData(policy.policyNumber,
          policy.detailTypeIdentifier.toLowerCase(), policy.lineOfBusinessId)">
                        {{ 'policy.file-a-claim' | translate }}<nx-icon name="launch"
                            class="nx-margin-left-2xs"></nx-icon>
                    </button>
                </span>
                <span *ngSwitchCase="lob.HomeInsurance">
                    <a href="{{'file-a-claim.'+commonService.env+'.lob_' + policy.lineOfBusinessId + responsibility | translate}}"
                        target="_blank" *ngIf="policy.canFileAClaim">
                        <button nxPlainButton type="button" class="file-a-claim" (click)="gtm()">
                            {{'policy.file-a-claim' | translate}}<nx-icon name="launch"
                                class="nx-margin-left-2xs"></nx-icon>
                        </button>
                    </a>
                </span>
                <span *ngSwitchCase="lob.CarInsurance">
                    <a href="{{'file-a-claim.'+commonService.env+'.lob_' + policy.lineOfBusinessId | translate}}"
                        target="_blank" *ngIf="policy.canFileAClaim">
                        <button nxPlainButton type="button" class="file-a-claim" (click)="gtm()">
                            {{'policy.file-a-claim' | translate}}<nx-icon name="launch"
                                class="nx-margin-left-2xs"></nx-icon>
                        </button>
                    </a>
                </span>
            </container-element>
        </cpc-policy-card-entry>
    </cpc-policy-card-content>
</cpc-policy-card>